import axios from "axios";

export function loginUser(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'api/tabulation/loginUser'
    })
}